import ApiService from './api.service.js'
// import { versionMajorMinor } from 'typescript'
import { isConstructorDeclaration, versionMajorMinor } from 'typescript'

const FinancialAdminService = {
  initFinancialData: async function () {
    try {
      let reqParams = {
        params: {
          action: 'financial-import'
        }
      }
      let financeResponse = await ApiService.get(process.env.VUE_APP_FINANCE_MONTHLY_GROSS, reqParams)
      return financeResponse.data
    } catch (error) {
      
      throw new Error('Error:' + error)
    }
  },
  getAllMonthlyCrossAccts: async function (callback) {
    try {
      console.log('montesssssst')
      let reqParams = {
        params: {
          action: 'financial-import'
        }
      }
      let requests = await ApiService.get(process.env.VUE_APP_FINANCE_MONTHLY_GROSS, reqParams)
      console.log('----- service: getAllMonthlyCrossAccts -----')
      console.log(requests.data)
      console.log('--------------------------------------------')
      if (requests.data.length) {
        callback(requests.data)
      } else {
        callback(null, { error: 'No Records Found' })
      }
    } catch (error) {
      
      throw new Error('Error:' + error)
    }
  },


  findSfdcId: async function(id, callback) {
    let reqParams = {
      params: {
        client_ID: id
      }
    }
    let reqResponse = await ApiService.get(process.env.VUE_APP_SALESFORCE_REGISTER_API, reqParams)
    callback(reqResponse.data.OpportunityStatus)
  },
  
  sanitizeKeys: function(financeRecord){
    console.log('----removeKeys-------')
    for (var propName in financeRecord) { 
      if (financeRecord[propName] === null || financeRecord[propName] === undefined || financeRecord[propName] === 'None') {
        console.log('1')
        delete financeRecord[propName];
      }
    }
    console.log(financeRecord)
    return financeRecord
  },

  updateFinanceAccount: async function (data, callback) {
    try {
      console.log('----- financeParams ------')
      console.log(this.sanitizeKeys(data))
      console.log('--------------------------')
      let sanitizeFinanceData = this.sanitizeKeys(data)
      let financeParams = {
        action: 'financial-import',
        ...sanitizeFinanceData
      }

      let financeResponse = await ApiService.put(process.env.VUE_APP_FINANCE_MONTHLY_GROSS, financeParams)
      if (!financeResponse.data) {
        callback(null, { message: 'Error updating customer' })
      } else {
        let response = { id: financeResponse.data.id, message: financeResponse.data.response }
        callback(response)
      }
    } catch (error) {

    }
  },

  processAWSBilling: async function (billingAccount, callback) {
    try {
      let request_data = {
        params: {
          id: billingAccount.masterPayer, type: billingAccount.processType,
          billingMonth: billingAccount.billingMonth,
        }
      }
      let res = await ApiService.get(process.env.VUE_APP_AWS_CLOUDCHECKER, request_data)
      callback(res.data)
    } catch (error) {
      callback(null)
    }
  }
 
}

export default FinancialAdminService
